import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Layout, Drawer } from "antd";
import useMediaModel from "../models/useMedia";
// import { useMediaQuery } from "react-responsive";
import { useSiderMenuToggleModel } from "../models/useToggle";
import AppMenu from "./AppMenu";
import defaultLogo from "../assets/images/default_logo.png";
import defaultFav from "../assets/images/default_favicon.png";
import { CompanyContext } from "../pages/userpersonal/companyContext";
const { Sider } = Layout;

const AppAside = (props) => {
  const menuCollapsed = useSiderMenuToggleModel();
  const isMobile = useMediaModel();
  // const isMobile = useMediaQuery({ query: "(max-width: 426px)" });
  let { menu } = props;
  const { companyDetails } = useContext(CompanyContext);
  
  return isMobile ? (
    <Drawer
      {...props}
      parent={null}
      level={null}
      visible={menuCollapsed.state}
      placement="left"
      onClose={menuCollapsed.set(false)}
      bodyStyle={{
        margin: 0,
        padding: 0,
        maxWidth: 240,
      }}
    >
      <Sider
        className="aside b-right-dark"
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          overflowX: "hidden",
          left: 0,
          minWidth: 240,
        }}
        trigger={null}
        collapsed={false}
      >
        <div className="logo">
          <a rel="noopener noreferrer" href="/dashboard">
            <img
              src={companyDetails?.logo}
              alt="logo"
              onError={(e) => {
                if (e.target.src !== defaultLogo) {
                  e.target.src = defaultLogo;
                }
              }}
            />
          </a>
        </div>

        <AppMenu menu={menu} menutoggle={!!menuCollapsed.state} />
      </Sider>
    </Drawer>
  ) : (
    <Sider
      width={240}
      className="aside b-right-dark"
      style={{
        overflow: "auto",
        height: "100vh",
        position: "fixed",
        overflowX: "hidden",
        left: 0,
      }}
      trigger={null}
      collapsible
      collapsed={menuCollapsed.state}
    >
      <div className="logo">
        <a rel="noopener noreferrer" href="/dashboard">
          {menuCollapsed.state ? (
            <img
              src={companyDetails?.favicon}
              alt="favicon"
              className="p-2"
              onError={(e) => {
                if (e.target.src !== defaultFav) {
                  e.target.src = defaultFav;
                }
              }}
            />
          ) : (
            <img
              src={companyDetails?.logo}
              // className="logo-img"
              alt="logo"
              onError={(e) => {
                if (e.target.src !== defaultLogo) {
                  e.target.src = defaultLogo;
                }
              }}
            />
          )}
        </a>
      </div>

      <AppMenu menu={menu} menutoggle={!!menuCollapsed.state} />
    </Sider>
  );
};

AppAside.propTypes = {
  menutoggle: PropTypes.bool,
  menu: PropTypes.array.isRequired,
};

export default AppAside;
